import {FormControl, FormHelperText, FormLabel, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, withStyles} from "@material-ui/core";
import React, {useState} from "react";
import Tr from "translations/Translations";
import AuditTaskUserRow from "./AuditTaskUserRow";
import getObjectValue from "../../../../libs/getObjectValue";
import {VALUES} from "../constants/AuditTaskType";
import AddIcon from "@material-ui/icons/Add";
import Button from "../../../../components/Button";
import AuditTaskUserPopup from "./AuditTaskUserPopup";

const style = theme => ({
    error: {
        marginTop: 0,
        marginBottom: theme.spacing(1),
    },
    cell: {
        padding: theme.spacing(1),
    },
    name: {
        width: 350,
        wordBreak: 'normal'
    },
    button: {
        width: 50,
        padding: '0 !important'
    },
    buttonNew: {
        width: 250,
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(1)
    },
    icon: {
        marginRight: theme.spacing(1)
    }
})

function AuditTaskUserTable({
    formikProps,
    required,
    editable,
    className,
    classes
}) {

    const id = 'auditUsers';
    const idCount = id + 'Count';
    const errorValue = getObjectValue(idCount, formikProps.errors, '');
    const touched = getObjectValue(idCount, formikProps.touched, false);
    const isError = !!errorValue && touched?.count;
    const helperText = isError ? errorValue : '';
    const _label = Tr('audit_task_users') + (required ? '*' : '');

    const auditUsers = getObjectValue(id, formikProps.values, []);
    const auditUsersCount = getObjectValue(idCount, formikProps.values, []);
    const type = getObjectValue('type', formikProps.values, null);
    const taskId = getObjectValue('identity', formikProps.values, null);

    const [userPopup, setUserPopup] = useState(false);

    const addEmptyUser = () => {
        auditUsers.push({
            identity: -1,
            firstName: '',
            lastName: '',
            email: '',
        });
        auditUsersCount.count = auditUsers.length;

        formikProps.setFieldTouched(`${idCount}.count`, true);
    }

    const pickUsers = (pickedUsers) => {
        if (VALUES.EXTERNAL === type)
            return;

        pickedUsers.forEach(u => {
            auditUsers.push({
                identity: -1,
                firstName: u.firstName,
                lastName: u.lastName,
                email: u.email,
                baseUserId: u.identity
            })
        });
        auditUsersCount.count = auditUsers.length;

        formikProps.setFieldTouched(`${idCount}.count`, true);
        setUserPopup(false);
    }

    const deleteUser = (index) => {
        auditUsers.splice(index, 1);
        auditUsersCount.count = auditUsers.length;
        formikProps.setFieldTouched(`${idCount}.count`, true);
    }

    return (
        <FormControl
            error={isError}
            className={className}
        >
            <FormLabel>{_label}</FormLabel>
            <TableContainer>
                <Table >
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.name}>{Tr("firstName")}</TableCell>
                            <TableCell className={classes.name}>{Tr("lastName")}</TableCell>
                            <TableCell className={classes.name}>{Tr("email")}</TableCell>
                            <TableCell className={classes.button}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!!auditUsers.length && auditUsers.map((user, index) =>
                            <AuditTaskUserRow
                                key={`au${index}`}
                                id={`auditUsers`}
                                index={index}
                                formikProps={formikProps}
                                type={type}
                                editable={editable}
                                taskId={taskId}
                                deleteUser={deleteUser}
                            />
                        )}
                        {!auditUsers.length && <TableRow>
                            <TableCell colSpan="4">{Tr('audit_task_users_empty')}</TableCell>
                        </TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
            <FormHelperText className={classes.error}>{helperText}</FormHelperText>
            {editable && VALUES.EXTERNAL === type && <Button
                className={classes.buttonNew}
                color={'primary'}
                variant={undefined}
                onClick={() => addEmptyUser()}

            >
                <AddIcon className={classes.icon}/>
                {Tr('audit_task_users_add')}
            </Button>}
            {editable && VALUES.INTERNAL === type && <Button
                className={classes.buttonNew}
                color={'primary'}
                variant={undefined}
                onClick={() => setUserPopup(true)}

            >
                <AddIcon className={classes.icon}/>
                {Tr('audit_task_users_choose')}
            </Button>}
            {editable && VALUES.INTERNAL === type && userPopup && <AuditTaskUserPopup
                taskId={taskId}
                excludeUserIds={auditUsers.map(u => u.baseUserId)}
                open={true}
                onCancel={() => setUserPopup(false)}
                onConfirm={(users) => pickUsers(users)}
            />}
        </FormControl>
    )
}

export default (withStyles(style)(AuditTaskUserTable));